_ = require('lodash')
moment = require('moment')
$ = require('jquery')

GroupTimelineCtrl = ($scope ,$translate ,$filter ,flash , $location , $ngConfirm , GroupTimelineService ) ->
  timeLineCtrl = this
  pageSize = 4
  timeLineCtrl.lstTimelines = []
  timeLineCtrl.currentPage = 0
  timeLineCtrl.isLoading = false
  timeLineCtrl.noResults = true
  timeLineCtrl.totalPages = 0

  timeLineCtrl.loadMore = ->
    timeLineCtrl.isLoading = true
    timeLineCtrl.currentPage++
    params =
      id : $scope.groupDetail.id
      page : timeLineCtrl.currentPage
      page_size : pageSize

    GroupTimelineService.getTimeLines(params)
    .then (data) ->
      timeLineCtrl.lstTimelines = _.union(timeLineCtrl.lstTimelines , data.timelines)
      timeLineCtrl.totalPages = data.total_pages
      timeLineCtrl.noResults = timeLineCtrl.lstTimelines.length == 0
    .finally ->
      timeLineCtrl.isLoading = false

  timeLineCtrl.submitReaction = (param) ->
    GroupTimelineService.submitReaction(param)

  timeLineCtrl.hasMore = ->
    timeLineCtrl.noResults == false && timeLineCtrl.currentPage < timeLineCtrl.totalPages

  timeLineCtrl.loadMore()
  timeLineCtrl

GroupTimelineCtrl.$inject = [
  '$scope'
  '$translate'
  '$filter'
  'flash'
  '$location'
  '$ngConfirm'
  'GroupTimelineService'
]

module.exports = GroupTimelineCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-timeline/group-timeline-controller.coffee